export default () => {
    function onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
            $event.preventDefault();
        }
    }

    function makeSlug(str) {
        return str.trim()
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function $t(str) {
        return Lang.get(str)
    }

    function setLang(lang) {
        Lang.setLocale(lang)
    }

    function capitalize(word) {
        const lower = word.toLowerCase();
        return word.charAt(0).toUpperCase() + lower.slice(1);
    }

    function dateOrdinalSuffix(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }

    function calculatePaymentGatewayFee(paymentGateway, total) {
        let percentageFee = 0;
        let fixedFee = 0;
        let feeDescription = '';

        if (paymentGateway.hasOwnProperty('percentage') || paymentGateway.hasOwnProperty('fixed_amount')) {
            if (parseFloat(paymentGateway.percentage) > 0) {
                percentageFee = (total * parseFloat(paymentGateway.percentage)) / 100;
            }

            if (parseFloat(paymentGateway.fixed_amount) > 0) {
                fixedFee = parseFloat(paymentGateway.fixed_amount);
            }
        }
        // Fall back to legacy fee structure
        else if (paymentGateway.fee > 0) {
            if (paymentGateway.fee_type === 'percentage') {
                percentageFee = (total * parseFloat(paymentGateway.fee)) / 100;
            } else {
                fixedFee = parseFloat(paymentGateway.fee);
            }
        }

        const totalFee = (percentageFee + fixedFee).toFixed(2);

        if (parseFloat(paymentGateway.percentage) > 0 && parseFloat(paymentGateway.fixed_amount) > 0) {
            feeDescription = ` (${paymentGateway.percentage}% + RM${parseFloat(paymentGateway.fixed_amount).toFixed(2)})`;
        } else if (parseFloat(paymentGateway.percentage) > 0) {
            feeDescription = ` (${paymentGateway.percentage}%)`;
        } else if (paymentGateway.fee_type === 'percentage' && !paymentGateway.hasOwnProperty('percentage')) {
            feeDescription = ` (${paymentGateway.fee}%)`;
        }

        return {
            value: totalFee,
            display: 'RM' + totalFee + feeDescription
        };
    }

    return { onlyNumber, makeSlug, $t, setLang, capitalize, dateOrdinalSuffix, calculatePaymentGatewayFee }
}
